export enum SessionStatus {
  STATUS_RECEPTED = 0,
  STATUS_PAID = 1,
  STATUS_UNPAID = 2,
  STATUS_PAYING = 3,
  STATUS_CANCELED = -1,
  STATUS_INVALID = -2,
}
